import {I18nKFunction} from 'i18n';

import {CategoryData, SolutionsData} from 'models/app';

export function transformSolutionsData(
    solutionsData: SolutionsData,
    i18nK: I18nKFunction,
): SolutionsData {
    if (!solutionsData.categories) {
        return solutionsData;
    }

    const categories: CategoryData[] = [];

    solutionsData.categories.forEach((category: CategoryData, id: number) => {
        categories.push({
            ...category,
            id,
            name: i18nK(`solutions-categories-${category.slug}`),
        });
    });

    return {
        ...solutionsData,
        categories,
    };
}
